import { ArrowDropUp, Menu as MenuIcon, SupervisedUserCircle } from "@mui/icons-material";
import { Menu as MenuMui, MenuItem as MenuItemMui, Box } from "@mui/material";
import { useState } from "react";
import { styled } from "@mui/material/styles";
import { MANUAL_PATH_LIST } from "utility/constants";
import { checkLanguage } from "utility";
import { useTranslation } from "react-i18next";
import { ReactComponent as Lab } from "assets/icons/lab.svg";
import { Link } from "react-router-dom";
import { ButtonNavbar } from "./MenuService";
import ReactGA from "react-ga4";
import { WhatIsNewFullScreen } from "sections/whatIsNew";
import { useSelector } from "redux/store";
import { selectPermissionAction } from "redux/slices/role";

export const Menu = styled(MenuMui)`
  & .MuiPaper-root {
    width: 100%;
    background-color: ${({ theme }) => theme.palette.primary.main};
    color: ${({ theme }) => theme.palette.primary.contrastText};
    box-shadow: none;
    border-radius: 0px;
    & .MuiMenu-list {
      padding-top: 0px;
      padding-bottom: 0px;
    }
  }
  & .MuiPopover-paper {
    top: 72px !important;
    left: 0px !important;
    max-width: inherit;
    ${({ theme }) => theme.breakpoints.down("sm")} {
      top: 50px !important;
    }
  }
`;
export const MenuItem = styled(MenuItemMui)`
  padding: 16px;
  box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.25);
  justify-content: center;
  :hover {
    background: #4b9752;
  }
`;

const MenuDrawer = ({
  username,
  handleContact,
  isBeta,
  isUsedBeta,
  setOpenDrawer,
  signOut,
  isAuth,
}) => {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openNewFeature, setOpenNewFeature] = useState(false);
  const isAllowDashboard = useSelector(selectPermissionAction)("dashboard:view");
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      {openNewFeature && (
        <WhatIsNewFullScreen open={openNewFeature} handleClose={() => setOpenNewFeature(false)} />
      )}
      <ButtonNavbar
        id="mobile-button-drawer"
        onClick={handleClick}
        sx={{ color: "var(--color-text)" }}
      >
        {open ? <ArrowDropUp /> : <MenuIcon />}
      </ButtonNavbar>
      <Menu id="mobile-button-menu" open={open} onClose={handleClose} anchorEl={anchorEl}>
        {isAuth ? (
          <Box>
            <MenuItem
              onClick={() => {
                handleClose();
                ReactGA.event("click_navigation", {
                  component: "navbar",
                  link: "profile",
                });
              }}
              component={Link}
              to="/profile"
            >
              <SupervisedUserCircle sx={{ marginRight: 1 }} /> {username}
            </MenuItem>
            <MenuItem
              onClick={() => {
                window.open(MANUAL_PATH_LIST[checkLanguage(i18n.language) === "th" ? "th" : "en"]);
                ReactGA.event("click_navigation", {
                  component: "navbar",
                  link: "manual",
                });
              }}
            >
              {t("appbar.help_manual")}
            </MenuItem>
            <MenuItem
              onClick={() => {
                setOpenNewFeature(true);
                ReactGA.event("click_navigation", {
                  component: "navbar",
                  link: "new feature",
                });
              }}
            >
              {t("appbar.help_new_feature")}
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleContact();
                ReactGA.event("click_navigation", {
                  component: "navbar",
                  link: "contact",
                });
              }}
            >
              {t("appbar.contact")}
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleClose();
                ReactGA.event("click_navigation", {
                  component: "navbar",
                  link: "inspection",
                });
              }}
              component={Link}
              to="/rice-inspect-option"
            >
              {t("appbar.rice_quality_inspection")}
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleClose();
                ReactGA.event("click_navigation", {
                  component: "navbar",
                  link: "history",
                });
              }}
              component={Link}
              to="/history-rice-inspect"
            >
              {t("appbar.rice_history")}
            </MenuItem>
            {isAllowDashboard && (
              <MenuItem
                onClick={() => {
                  handleClose();
                  ReactGA.event("click_navigation", {
                    component: "navbar",
                    link: "dashboard",
                  });
                }}
                component={Link}
                to="/dashboard"
              >
                {t("appbar.statisticalData")}
              </MenuItem>
            )}
            {/* <MenuItem */}
            {/*   onClick={() => { */}
            {/*     handleClose(); */}
            {/*     ReactGA.event("click_navigation", { */}
            {/*       component: "navbar", */}
            {/*       link: "setting", */}
            {/*     }); */}
            {/*   }} */}
            {/*   component={Link} */}
            {/*   to="/setting" */}
            {/* > */}
            {/*   {t("appbar.setting")} */}
            {/* </MenuItem> */}
            {isBeta && (
              <MenuItem
                onClick={() => {
                  handleClose(), setOpenDrawer(true);
                }}
              >
                <Lab style={{ marginRight: "6px" }} />
                {isUsedBeta ? t("beta.back_to_non_beta") : t("beta.beta_test")}
              </MenuItem>
            )}
            <MenuItem onClick={signOut} sx={{ background: "#ffffff", color: "error.content" }}>
              {t("appbar.logout")}
            </MenuItem>
          </Box>
        ) : (
          <MenuItem onClick={handleContact}>{t("appbar.contact")}</MenuItem>
        )}
      </Menu>
    </>
  );
};

export default MenuDrawer;
